import { Component, OnInit } from '@angular/core';
import { B2bComponent } from '../b2b.component';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Subject } from 'rxjs';
import { debounceTime, finalize  } from 'rxjs/operators';
import { B2BService } from 'src/app/b2-b.service';
import { HostListener } from '@angular/core'; // make sure this is imported
import { 
  ColDef, 
  GridApi, 
  ColumnApi, 
  PasteStartEvent, 
  PasteEndEvent 
} from 'ag-grid-community';

@Component({
  selector: 'app-list-prices-ag-grid',
  templateUrl: './list-prices-ag-grid.component.html',
  styleUrls: ['./list-prices-ag-grid.component.css']
})
export class ListPricesAgGridComponent implements OnInit {

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (this.gridApi) {
      this.gridApi.resetRowHeights(); // Optional if height changes
      this.gridApi.sizeColumnsToFit(); // Resize columns to fit available space
    }
  }

  constructor(public parent: B2bComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  private pastedLineCount: number = 0;
  private pastedRows: { rowIndex: number; name: string; quantity: any }[] = [];
  private pasteSubject = new Subject<void>();

  private readonly MAX_PASTE_ROWS = 150;
  private allowedPastedRowIndices: Set<number> = new Set();

  private pendingSearchRequests: number = 0;
  private pasteBatchInProgress: boolean = false;

  private pendingPasteRowIndexes: Set<number> = new Set();
  private pasteSyncTimer: any = null;

  namePlaceholder: string = '';
  specialPriceCellTranslation: string = '';
  MOQAdjustmentTooltip: string = '';
  searchTermUpdate = new Subject<string>();
  CurrentCartItemRow:any;
  Language:any;

  AskAddNewRFQQuestion:boolean = false;  

  OpenAskAddNewRFQQuestion(){
    // this.OfferRequest.DebatorPO = "";
    this.AskAddNewRFQQuestion = true;
    this.InitializeCart();
  }

  AskAddNewRFQasPOQuestion:boolean = false;  

  OpenAskAddNewRFQasPOQuestion(){
    // this.OfferRequest.DebatorPO = "";
    this.AskAddNewRFQasPOQuestion = true;
    this.InitializeCart();
  }
  
  async AddNewOfferRequest(POButtonPressed: boolean = false, cart: any = null) {
    await this.parent.AddNewOfferRequest(POButtonPressed, cart);
    // this.AskAddNewRFQasPOQuestion = false;
    // this.AskAddNewRFQQuestion = false;
  }
  columnDefs = [
    {
      headerName: '#',
      field: 'index',
      valueGetter: 'node.rowIndex + 1',
      editable: false,
      minWidth: 25,
      flex: 0.5,
      suppressSizeToFit: true,
      suppressMenu: true
    },
    {
      headerName: 'Brand',
      field: 'brand',
      editable: false,
      minWidth: 150,
      flex: 4,
      suppressMenu: true,
      cellRenderer: this.BrandCellRenderer.bind(this),
      cellClassRules: {
        'GridAwaitingSelection': (p: any) => p.data?.CartItem?.CartItemStatus?.ID === -1
      }
    },
    {
      headerName: 'PartNumber',
      field: 'partNumber',
      editable: false,
      minWidth: 125,
      flex: 2,
      suppressMenu: true
    },
    {
      headerName: 'Name',
      field: 'name',
      editable: true,
      minWidth: 250,
      flex: 6,
      suppressMenu: true,
      cellRenderer: this.NameCellRenderer.bind(this),
      cellClassRules: {
       'GridAwaitingSelection': (p: any) => p.data?.CartItem?.CartItemStatus?.ID === -1
      }
    },
    {
      headerName: 'Qty',
      field: 'quantity',
      editable: true,
      type: 'numericColumn',
      valueParser: this.numberParser,
      minWidth: 60,
      flex: 1,
      suppressMenu: true,
      cellClassRules: {
        'quantity-modified': (params: any) =>
          params.data?.CartItem?.SelectedOffer?.ChangedQunatityFromMOQ === true
      },
      tooltipValueGetter: function (params) {
        return params.data?.CartItem?.SelectedOffer?.ChangedQunatityFromMOQ
          ? params.context.componentParent.MOQAdjustmentTooltip
          : null;
      },
      tooltipComponentParams: {
        class: 'custom-moq-tooltip'
      }
    },
    {
      headerName: 'Price/Unit',
      field: 'price',
      editable: false,
      minWidth: 100,
      flex: 2,
      suppressMenu: true,
      cellRenderer: this.priceCellRenderer.bind(this)
    },
    {
      headerName: 'Total',
      field: 'total',
      editable: false,
      minWidth: 100,
      flex: 2,
      suppressMenu: true
    },
    {
      headerName: 'ETA',
      field: 'eta',
      editable: false,
      minWidth: 125,
      flex: 2,
      suppressMenu: true,
      cellRenderer: this.ETACellRenderer.bind(this),
    },
    {
      headerName: 'HSCode',
      field: 'hscode',
      editable: false,
      minWidth: 125,
      flex: 2,
      suppressMenu: true
    },
    {
      headerName: 'COO',
      field: 'coo',
      editable: false,
      minWidth: 75,
      flex: 0.75,
      suppressMenu: true
    },
    {
      headerName: 'Weight',
      field: 'weight',
      editable: false,
      minWidth: 75,
      flex: 0.75,
      suppressMenu: true
    },
    {
      headerName: '',
      field: 'delete',
      minWidth: 25,
      flex: 0.5,
      suppressMenu: true,
      suppressSorting: true,
      editable: false,
      suppressSizeToFit: true,
      cellRenderer: () => {
        return `<button class="delete-row-button material-icon-trigger" title="Delete row">
                  <i class="material-icons">close</i>
                </button>`;
      }
    }
  ];

  rowData: any[] = [];
  defaultColDef = {
    resizable: true,
    // sortable: true,
    // filter: true,
    flex: 1,
    minWidth: 100,
    cellClass: (params: any) => {
      return params.colDef.field === 'name' ? 'cell-white' : 'cell-gray';
    }
  };

  gridOptions = {
    rowHeight: 30,
    headerHeight: 30,
    enableRangeSelection: true,
    suppressClipboardApi: true,
    enableFillHandle: true,
    enableClipboard:true,
    suppressClipboardPaste: false,
    suppressLastEmptyLineOnPaste: true,
    rowSelection: 'multiple',
    suppressRowClickSelection: true,
    stopEditingWhenCellsLoseFocus: true,
    singleClickEdit: false,
    undoRedoCellEditing: true,
    tooltipShowDelay: 0,      // Show immediately
    tooltipHideDelay: 10000,   // Optional: auto-hide after 2s
    enableBrowserTooltips: true,
    context: {
      componentParent: this
    },
    undoRedoCellEditingLimit: 20,
    domLayout: 'autoHeight',
    /** <-- replace getRowClass with this */
    rowClassRules: {
      // GridAwaitingSelection: p => p.data?.CartItem?.CartItemStatus?.ID === -1,
      GridNotValid:         p => p.data?.CartItem?.CartItemStatus?.ID === 0,
      GridValid:            p => p.data?.CartItem?.SelectedOffer?.IsStockOffer === true,
    },
    onGridReady: (params: any) => params.api.sizeColumnsToFit(),
    onCellValueChanged: (event: any) => this.onCellValueChanged(event),
    onPasteEnd: (params: any) => this.handlePaste(params),
    getRowClass: (params: any) => {
      const CartItem = params.data?.CartItem;
      if (!CartItem) return null;
  
      return null; // No class
    },
    suppressKeyboardEvent: (params) => {
      const isPaste = params.event.code === 'KeyV' && (params.event.ctrlKey || params.event.metaKey);
      if (isPaste) {
        params.api.stopEditing(); // forcefully exit edit mode
      }
      return false; // allow paste to continue
    },
    onPasteStart: (params) => {
      console.log('🔍 onPasteStart triggered', params);
    },
  };
  
  private gridApi!: GridApi;
  private columnApi!: ColumnApi;

  priceCellRenderer(params: any): string {
    const price = params.value ?? '';
    const cartItem = params.data?.CartItem;
    const translate = params.context?.translate;
  
    let showTriangle = false;
    let tooltipText = '';
    let priceClass = '';
  
    // Check for MOQ-based special offer
    let moq = null;
    if (Array.isArray(cartItem?.SearchResults)) {
      const special = cartItem.SearchResults.find((x: any) => x.SpecialOffer === true && x.MOQ > 1 && x.FKBrandID == cartItem?.Product?.Brand?.ID);
      if (special) {
        moq = special.MOQ;
        showTriangle = true;
        const translatedText = translate?.instant('IncreaseQuantityForSpecialPrice') ?? 'Special Price for min:';
        tooltipText = `${translatedText} ${moq}`;
      }
    }
  
    // Check for SpecialPriceList flag
    const isSpecialList = cartItem?.SelectedOffer?.Configuration?.SpecialPriceList === true;
    if (isSpecialList) {
      showTriangle = true;
      if (!tooltipText) {
        tooltipText = translate?.instant('IncreaseQuantityForSpecialPrice') ?? 'Special price available';
      }
      priceClass = 'special-price-highlight';
    }
  
    const triangle = showTriangle
      ? `<span class="price-corner-triangle" title="${tooltipText}"></span>`
      : '';
  
    return `
      <div class="price-cell-wrapper">
        <span class="${priceClass}">${price}</span>
        ${triangle}
      </div>
    `;
  }
  

  ETACellRenderer(params: any): string {
    const rowIndex = params.rowIndex;
    const cartItem = params.data?.CartItem;
  
    // Build ETA text + "(Stock)" just like your old valueGetter
    const base = (params.data?.eta || '').toString().trim();
    const isStock = cartItem?.SelectedOffer?.IsStockOffer;
    const etaText = (base + (isStock ? (base ? ' ' : '') + '(Stock)' : '')).trim() || '------';
  
    // Show the same dropdown condition as your Name column
    const hasDropdown = cartItem?.CartItemStatus?.ID === 1;
  
    const dropdownButton = hasDropdown
      ? `<button class="dropdown-trigger material-icon-trigger" data-row="${rowIndex}" data-type="ALLETAs" title="View ALL ETA's">
           <i class="material-icons">expand_more</i>
         </button>`
      : '';
  
    // 🔴 Use the SAME wrapper classes as Name so existing CSS applies
    return `
      <span class="name-cell-content">
        <span class="${base ? 'eta-text' : 'eta-placeholder'}">${etaText}</span>
        <span class="cell-actions">${dropdownButton}</span>
      </span>
    `;
  }

  // add to the component class
  BrandCellRenderer(params: any): string {
    const brand = (params.value ?? '').toString().trim();
    const rowIndex = params.rowIndex;
    const cartItem = params.data?.CartItem;
  
    const statusId = cartItem?.CartItemStatus?.ID;
  
    // Existing condition (awaiting selection / valid w/ collateral)
    const showExistingButton =
      cartItem?.WasSearchedFor == true &&
      (statusId === -1 || statusId === 1);
  
    // NEW condition: show **suggestion** button only when NOT VALID (ID === 0)
    const showSuggestButton = statusId === 0;
  
    const existingBtn = showExistingButton
      ? `<button class="dropdown-trigger dropdown-trigger-brand material-icon-trigger"
                   data-row="${rowIndex}"
                   data-type="brand-collateral"
                   title="View brand alternatives">
           <i class="material-icons">expand_more</i>
         </button>`
      : '';
  
    // 🔵 New button (same look), uses data-type="brand-suggest"
    const suggestBtn = showSuggestButton
      ? `<button class="dropdown-trigger dropdown-trigger-brand material-icon-trigger"
                   data-row="${rowIndex}"
                   data-type="brand-suggest"
                   title="Suggest brands for this product">
           <i class="material-icons">expand_more</i>
         </button>`
      : '';
  
    return `
      <span class="brand-cell-content">
        <span class="brand-text">${brand}</span>
        <span class="cell-actions">
          ${existingBtn}
          ${suggestBtn}
        </span>
      </span>
    `;
  }
  
  NameCellRenderer(params: any): string {
    const eta = params.value?.toString().trim() ?? '';
    const isEmpty = eta.length === 0;
    const rowIndex = params.rowIndex;
    const cartItem = params.data?.CartItem;
    const placeholder = this.namePlaceholder || 'Search product or part number...';
  
     // 🔸 Show fallback dropdown when in "awaiting selection" state
    const showFallbackDropdown = cartItem?.CartItemStatus?.ID === -1;

    const hasDropdown = cartItem?.CartItemStatus?.ID === 1 && cartItem?.SearchResults?.length > 1;
    const dropdownButton = hasDropdown
      ? `<button class="dropdown-trigger material-icon-trigger" data-row="${rowIndex}" data-type="productalternatives" title="View Product-Alternatives">
           <i class="material-icons">expand_more</i>
         </button>`
      : '';

    const fallbackButton = showFallbackDropdown
    ? `<button class="dropdown-trigger material-icon-trigger fallbackButtonTrigger" data-row="${rowIndex}" data-type="fallback" title="Show UI fallback offers">
         <i class="material-icons">expand_more</i>
       </button>`
    : '';
  
    const displayText = isEmpty
      ? `<span class="name-placeholder">${placeholder}</span>`
      : `<span class="name-text">${eta}</span>`;
  
    return `
      <span class="name-cell-content">
        ${displayText}
        <span class="cell-actions">
          ${dropdownButton}
          ${fallbackButton}
        </span>
      </span>
    `;
  }

  isHovering = false;

  ngOnInit(): void {

    this.translate.use(this.parent.getLanguage()).subscribe(() => {
      // Load translations at once
      this.translate.get([
        'SearchProductOrPartNumberHere',
        'MOQAdjustmentClientUI'
      ]).subscribe(translations => {
        this.namePlaceholder = translations['SearchProductOrPartNumberHere'];
        this.MOQAdjustmentTooltip = translations['MOQAdjustmentClientUI'];
        this.specialPriceCellTranslation = translations["IncreaseQuantityForSpecialPrice"];
  
        // Now that translations are ready, proceed
        this.InitializeFilter();
        this.GetB2BHomePageMessage();
        this.CartItemRows = [];
  
      });
    });

      // ✅ Intercept and count clipboard lines — used only for info
      // document.addEventListener('paste', (event: ClipboardEvent) => {
      //   const text = event.clipboardData?.getData('text/plain') ?? '';
      //   const lines = text.split(/\r?\n/).filter(line => line.trim());
      //   this.pastedLineCount = lines.length;
      // });

    // Debounce paste handling
    this.pasteSubject
        .pipe(debounceTime(250))
        .subscribe(() => {
          const unique = new Map<number, { name: string; quantity: any }>();
          this.pastedRows.forEach(r => unique.set(r.rowIndex, { name: r.name, quantity: r.quantity }));
          this.pastedRows = [];

          const entries = Array.from(unique.entries());
          if (entries.length === 0) return;

          for (const [rowIndex, payload] of entries) {
            if (this.shouldSearch(rowIndex)) {
              this.pendingPasteRowIndexes.add(rowIndex);

              this.SearchIndustryProductB2BOffersVersion2(rowIndex, payload.name, payload.quantity, () => {
                this.onPasteRowCompleted(rowIndex);
              });
            }
          }

          this.resetPasteCompletionTimer(); // fallback just in case
        });

        document.addEventListener('copy', this.onCopyHandler.bind(this));
  }

  onCopyHandler(e: ClipboardEvent): void {
    if (!this.gridApi || !this.gridApi.getFocusedCell()) return;
  
    const range = this.gridApi.getCellRanges()?.[0];
    if (!range) return;
  
    const rowStart = range.startRow.rowIndex;
    const rowEnd = range.endRow.rowIndex;
    const allCols = range.columns;
  
    // Step 1: Collect all data from selected rows
    const rawRows: string[][] = [];
    const colValuePresence = new Array(allCols.length).fill(false); // Track non-empty columns
  
    for (let i = rowStart; i <= rowEnd; i++) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(i);
      const row: string[] = [];
  
      allCols.forEach((col, colIndex) => {
        const value = (this.gridApi.getValue(col, rowNode) ?? '').toString().trim();
        row.push(value);
        if (value.length > 0) {
          colValuePresence[colIndex] = true;
        }
      });
  
      rawRows.push(row);
    }
  
    // Step 2: Build list of columns to keep (those with at least one non-empty value)
    const includedColIndexes = allCols
      .map((_, idx) => idx)
      .filter(idx => colValuePresence[idx]);
  
    const includedCols = includedColIndexes.map(idx => allCols[idx]);
  
    // Step 3: Build plain text (fallback)
    const plainText = rawRows
      .map(row => includedColIndexes.map(i => row[i]).join('\t'))
      .join('\n');
  
    // Step 4: Build HTML table
    let html = '<table border="1" cellpadding="4" cellspacing="0" style="border-collapse: collapse;">';
  
    // Header
    html += '<thead><tr>';
    for (const col of includedCols) {
      html += `<th style="background: #020044; color: #ffffff; font-size: 14px; font-weight: normal;">${col.getColDef().headerName || ''}</th>`;
    }
    html += '</tr></thead>';
  
    // Body
    html += '<tbody>';
    for (const row of rawRows) {
      html += '<tr>';
      for (const i of includedColIndexes) {
        html += `<td style="font-size: 12px;">${row[i]}</td>`;
      }
      html += '</tr>';
    }
    html += '</tbody></table>';
  
    // Step 5: Apply to clipboard
    e.preventDefault();
    e.clipboardData.setData('text/plain', plainText);
    e.clipboardData.setData('text/html', html);
  }

  private onPasteRowCompleted(rowIndex: number): void {
    this.pendingPasteRowIndexes.delete(rowIndex);
  
    if (this.pendingPasteRowIndexes.size === 0) {
      this.triggerFinalCartUpdate();
    }
  }

  private resetPasteCompletionTimer(): void {
    if (this.pasteSyncTimer) {
      clearTimeout(this.pasteSyncTimer);
    }
  
    this.pasteSyncTimer = setTimeout(() => {
      if (this.pendingPasteRowIndexes.size > 0) {
        console.warn('⚠️ Fallback: Force cart update after timeout');
        this.pendingPasteRowIndexes.clear();
        this.triggerFinalCartUpdate();
      }
    }, 10000); // Fallback timeout: 10 seconds
  }

  private triggerFinalCartUpdate(): void {
    this.UpdateCart();
    console.log('✅ All pasted rows processed, cart updated.');
  }

    /** Return true if we are allowed to search for this row */
  private shouldSearch(rowIndex: number): boolean {
    const node = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
    const wasSearched = node?.data?.CartItem?.WasSearchedFor === true;
    return !wasSearched; // allow when false/undefined/null
  }

  onGridReady(params: any): void {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    const storedCart = localStorage.getItem("Cart");
      if (storedCart) {
        this.GetCart();
      } else {
        this.addMoreRows(50);
      }
  
    // Listen to raw paste to count rows
    // const gridElement = document.querySelector('.ag-root') as HTMLElement;
    // if (gridElement) {
    //   gridElement.addEventListener('paste', (e: ClipboardEvent) => {
    //     const text = e.clipboardData?.getData('text/plain') ?? '';
    //     this.pastedLineCount = text.split(/\r?\n/).filter(line => line.trim()).length;
    //   });
    // }
  
    // Attach custom grid cell click listener
    setTimeout(() => {
      const gridElement = document.querySelector('.ag-root');
      if (gridElement) {
        gridElement.addEventListener('click', this.onGridCellButtonClick.bind(this));
      }
    }, 0);
  }

  ClickedRow:any;
  ClickedRowIndex:number;
  ShowBrandCollateral: boolean = false;
  BrandPopupPosition: { top: string; left: string; width: string } = {
    top: '0px',
    left: '0px',
    width: '0px'
  };

  onGridCellButtonClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
  
    // delete button (unchanged)
    if (target.closest('.delete-row-button')) {
      const cell = target.closest('.ag-cell') as HTMLElement;
      const rowElement = cell?.parentElement as HTMLElement;
      const rowIndex = Array.from(rowElement?.parentElement?.children || []).indexOf(rowElement);
      if (rowIndex >= 0) this.deleteRow(rowIndex);
      return;
    }
  
    // accept clicks on either button or its <i> icon
    const trigger = target.closest('.dropdown-trigger, .dropdown-trigger-brand') as HTMLElement | null;
    if (!trigger) return;
  
    const rowIndex = Number(trigger.getAttribute('data-row'));
    const type = trigger.getAttribute('data-type') || 'name';
    const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
    const cartItem = rowNode?.data?.CartItem;
    if (!cartItem) return;
  
    this.ClickedRow = JSON.parse(JSON.stringify(rowNode?.data));
    this.ClickedRowIndex = rowIndex;
  
    const cellElement = trigger.closest('.ag-cell') as HTMLElement;
    const containerElement = document.querySelector('.OwnAGGridContainer') as HTMLElement;
    if (!cellElement || !containerElement) return;
  
    const cellRect = cellElement.getBoundingClientRect();
    const containerRect = containerElement.getBoundingClientRect();
    const top  = cellRect.top  - containerRect.top + cellElement.offsetHeight + 5;
  
    if (type === 'brand-collateral') {
      // 👉 brand-only popup: width = brand cell width, left = brand cell left
      const left = cellRect.left - containerRect.left;
      const width = cellRect.width;
  
      this.BrandPopupPosition = {
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`
      };
  
      // load brands for this row and show popup
      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.ShowFallbackSelection = false;
  
      // ensure you pass rowIndex so we can attach the list back on that row
      this.SearchIndustryProductNameAndPartNumberParrallelB2BBrandsVersion2(rowIndex, cartItem);
      return;
    }
    else if (type === 'brand-suggest') {
      this.BrandPopupPosition = {
        top: `${top}px`,
        left: `${cellRect.left - containerRect.left}px`,
        width: `${cellRect.width}px`
      };
  
      // Read implicit product from the **Name** column, as it is shown now
      const implicitProduct = (cartItem?.UIProductValue ?? '');
  
      // Use same popup; clear other overlays
      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.ShowFallbackSelection = false;
      this.ShowBrandCollateral = false;
      this.BrandSelectList = [];      // reset visible list
  
      // ⚠️ Exactly as requested: trigger your existing function
      //    with searchTerm = '' and implicitProduct = Name cell text
      this.InitializeBrandFilter();
      this.GetBrandsFilteredWithSuggestion('', 1, implicitProduct);
      return;
    }
  
    // existing ETA / fallback / search full-width popup
    const fullLeft = 5; // align with grid container's left
    const fullWidth = containerRect.width;
    this.SearchResultsPosition = { top: `${top}px`, left: `${fullLeft}px`, width: `${fullWidth}px` };
  
    if (type === 'fallback') {
      this.ShowUISideOffers(rowIndex, cartItem);
      return;
    }
    if (type === 'productalternatives' || type === 'ALLETAs') {
      this.ShowETAAlternatives = true;
      this.ShowSearchResultsAlternatives = false;
      const productIds = (cartItem?.SearchResults ?? []).map((s: any) => s.ProductID);
      const offerId = cartItem?.Product?.ListPriceOffers?.[0]?.ID;

      if(type === 'productalternatives'){
        if (productIds?.length) this.GetIndustryProductCalculatedSideOffersWithCollateral(rowIndex, productIds, offerId, this.ClickedRow?.CartItem?.Product?.Brand, true, true);
        return;
      }
      else if(type === 'ALLETAs'){
        this.GetIndustryProductCalculatedSideOffers(rowIndex, this.ClickedRow?.CartItem?.Product?.ID, offerId);
        return;
      }
    }
  
    //this is the old part that showed all 
    this.ShowSearchResultsAlternatives = true;
    this.ShowETAAlternatives = false;
    this.SearchResultAlternatives = JSON.parse(JSON.stringify(cartItem?.SearchResults ?? []));
  }

  ShowFallbackSelection:boolean = false;
  FallbackOffers:any[];

  ShowUISideOffers(rowIndex: number, cartItem:any): void {
    console.log('🟡 ShowUISideOffers triggered for row', rowIndex);
    this.ShowFallbackSelection = true;
    this.FallbackOffers = null;
    this.FallbackOffers = [];
    // You can implement the logic later, e.g., open a popup or fallback search.

    this.FallbackOffers = cartItem?.FallbackOffers;
  }

  deleteRow(rowIndex: number): void {
    const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;
  
    const dataToRemove = rowNode.data;
  
    // Remove row from AG Grid
    this.gridApi.applyTransaction({ remove: [dataToRemove] });
  
    // ✅ Optional: Re-index the remaining rows for correct # display
    const allData: any[] = [];
    this.gridApi.forEachNode((node, idx) => {
      node.data.index = idx + 1;
      allData.push(node.data);
    });
    this.gridApi.setRowData(allData); // reset with updated indices
  
    // ✅ Now persist the updated cart
    this.UpdateCart();
  }
  
  CloseGridPopupsOverlay(){
    this.ShowSearchResultsAlternatives = false;
    this.ShowETAAlternatives = false;
    this.ShowFallbackSelection = false;
    this.ShowBrandCollateral = false;
    this.ShowBrandCollateralNewProduct = false;
  }

  ShowSearchResultsAlternatives:boolean = false;
  ShowETAAlternatives:boolean = false;
  SearchResultAlternatives:any[];

  showSearchResultDropdown(rowIndex: number, searchResults: any[]): void {
    this.ShowSearchResultsAlternatives = true;
    this.SearchResultAlternatives = JSON.parse(JSON.stringify(searchResults));
  
    setTimeout(() => {
      const cellButton = document.querySelector(`.dropdown-trigger[data-row="${rowIndex}"]`) as HTMLElement;
      const gridContainer = document.querySelector('.OwnAGGridContainer') as HTMLElement;
  
      if (!cellButton || !gridContainer) return;
  
      // Accumulate offset relative to grid container
      let offsetTop = 0;
      let offsetLeft = 0;
      let el: HTMLElement | null = cellButton;
  
      while (el && el !== gridContainer) {
        offsetTop += el.offsetTop;
        offsetLeft += el.offsetLeft;
        el = el.offsetParent as HTMLElement;
      }
  
      this.SearchResultsPosition = {
        top: `${offsetTop + cellButton.offsetHeight}px`, // below the cell
        left: `${offsetLeft}px`,                         // aligned left
        width: '450px'                                   // match 'name' column width
      };
    }, 0);
  }

  SearchResultsPosition: { top: string; left: string; width: string } = {
    top: '0px',
    left: '0px',
    width: '0px'
  };

  onCellValueChanged(event: any): void {
    const field = event.colDef.field;

    // Only process 'name' or 'quantity'
    if (field !== 'name' && field !== 'quantity') {
      return;
    }
  
    const rowIndex = event.rowIndex;
    const rowNode = event.api.getDisplayedRowAtIndex(rowIndex);
  
    // 🚫 Prevent search logic for rows beyond paste limit
    if (this.pastedLineCount > this.MAX_PASTE_ROWS && rowIndex >= this.MAX_PASTE_ROWS) {
      console.warn(`⛔ Skipping row ${rowIndex} due to paste overflow.`);
      return;
    }
  
    // ✅ Quantity field changed
    if (field === 'quantity') {
      const cartItem = rowNode?.data?.CartItem;
      const newVal = (event.newValue ?? '').toString().trim();
      const oldVal = (event.oldValue ?? '').toString().trim();
  
      if (oldVal !== newVal && oldVal.length > 0 && newVal.length > 0) {
        const quantityValue = event.newValue ?? rowNode?.data?.quantity ?? null;
        this.ChangeGridQuantityVersion2(rowIndex, quantityValue, cartItem);
        return;
      }
    }
  
    // ✅ Name field logic
    const newValue = (event.newValue ?? '').toString().trim();
    if (!newValue) return;
  
    const oldValue = (event.oldValue ?? '').toString().trim();
    if (oldValue !== newValue && oldValue.length > 0 && newValue.length > 0) {
      if (rowNode?.data?.CartItem?.WasSearchedFor === true) {
        rowNode.data.CartItem.WasSearchedFor = false;
      }
    }
  
    const wasSearched = rowNode?.data?.CartItem?.WasSearchedFor === true;
    if (wasSearched) return;
  
    const quantity = rowNode?.data?.quantity ?? '';
    this.pastedRows.push({
      rowIndex,
      name: newValue,
      quantity
    });
  
    this.pasteSubject.next();
  }
  
  handlePaste(params: any): void {
    this.gridApi.stopEditing(); // ✅ Prevent AG Grid from showing paste confirmation

    this.pastedRows = null;
    this.pastedRows = [];
  
    const seen = new Set<number>();
    const allPastedRows: { rowIndex: number; name: string; quantity: any }[] = [];
  
    params.api.forEachNode((node: any) => {
      if (!node || node.rowIndex == null) return;
  
      const rowIndex = node.rowIndex;
      const name = node.data?.name ?? '';
      if (!name || !name.trim()) return;
  
      if (!seen.has(rowIndex)) {
        const quantity = node.data?.quantity ?? '';
        allPastedRows.push({ rowIndex, name, quantity });
        seen.add(rowIndex);
      }
    });
  
    let trimmedRows = allPastedRows;
    if (allPastedRows.length > this.MAX_PASTE_ROWS) {
      trimmedRows = allPastedRows.slice(0, this.MAX_PASTE_ROWS);
  
      for (let i = this.MAX_PASTE_ROWS; i < allPastedRows.length; i++) {
        const rowIndex = allPastedRows[i].rowIndex;
        const node = this.gridApi.getDisplayedRowAtIndex(rowIndex);
        if (node?.data) {
          node.setDataValue('name', '');
          node.setDataValue('quantity', null);
        }
      }
  
      this.parent.openSnackBar(
        `⚠️ Paste limited to ${this.MAX_PASTE_ROWS} items.`,
        'OK',
        'alert-info-snackbar'
      );
    }
  
    const lastRowIndex = trimmedRows.length > 0
      ? trimmedRows[trimmedRows.length - 1].rowIndex
      : 0;
  
    const currentRowCount = this.gridApi.getDisplayedRowCount();
    const requiredRowCount = lastRowIndex + 1;
  
    const finalize = () => {
      this.pastedRows.push(...trimmedRows);
      this.pasteSubject.next();
  
      // ✅ RESET counter after successful paste
      this.pastedLineCount = 0;
    };
  
    if (requiredRowCount > currentRowCount) {
      const rowsToAdd = requiredRowCount - currentRowCount;
      this.addMoreRows(rowsToAdd);
  
      setTimeout(finalize, 50);
    } else {
      finalize();
    }
  
    console.log('📋 Trimmed + cleaned paste rows:', trimmedRows.length);
  }
  

  LoadingSideOffers:boolean = false;
  SideOffers:any[];

  GetIndustryProductCalculatedSideOffersWithCollateral(rowIndex:number, IndustryProductIDs:number[], offerId:number, UIBrand:any, BestOfferOnly:boolean, GetAlsoCollateralSpecialOffers:boolean){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.parent.B2BPartner?.ID,
      IndustryProductIDs:IndustryProductIDs,
      SelectedOfferID:offerId,
      BestOfferOnly:BestOfferOnly,
      GetAlsoCollateralSpecialOffers:GetAlsoCollateralSpecialOffers,
      Brand:UIBrand,
    };

    this.SideOffers = null;
    this.SideOffers = [];

    this.LoadingSideOffers = true;
  
    this.B2BService.GetIndustryProductCalculatedSideOffersWithCollateral(request).subscribe(response => {
  
      if(response["Status"] != 1){
        // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SideOffers = JSON.parse(JSON.stringify(response["CartItems"]));
      }
  
      this.LoadingSideOffers = false;
     });
  }

  GetIndustryProductCalculatedSideOffers(rowIndex:number, IndustryProductID:number, offerId:number){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.parent.B2BPartner?.ID,
      IndustryProductID:IndustryProductID,
      SelectedOfferID:offerId
    };

    this.SideOffers = null;
    this.SideOffers = [];

    this.LoadingSideOffers = true;
  
    this.B2BService.GetIndustryProductCalculatedSideOffers(request).subscribe(response => {
  
      if(response["Status"] != 1){
        // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SideOffers = JSON.parse(JSON.stringify(response["CartItems"]));
      }
  
      this.LoadingSideOffers = false;
     });
  }

  GetIndustryProductByStockOverRequestedQuantity(rowIndex:number, overFlowingCartItem:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.parent.B2BPartner?.ID,
      CartItem:overFlowingCartItem,
    };

    this.SideOffers = null;
    this.SideOffers = [];

    this.LoadingSideOffers = true;
  
    this.B2BService.GetIndustryProductByStockOverRequestedQuantity(request).subscribe(response => {
  
      if(response["Status"] != 1){
        // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SideOffers = JSON.parse(JSON.stringify(response["CartItems"]));
      }
  
      this.LoadingSideOffers = false;
     });
  }
  
  SearchIndustryProductB2BOffersVersion2(rowIndex: number, searchTerm: string, quantity: any, callback?: () => void) {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      BrandID: null,
      SearchTerm: searchTerm,
      Quantity: quantity,
      Pager: { PageIndex: 1, PageSize: 10 },
      MaxRank: 10,
    };
  
    const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
    if (rowNode?.data?.CartItem) {
      rowNode.data.CartItem.LoadingCell = true;
      this.gridApi.refreshCells({
        rowNodes: [rowNode],
        columns: ['name'],
        force: true
      });
    }

    this.loadingProducts = true;
  
    this.B2BService.SearchIndustryProductB2BOffersVersion2(request).subscribe(response => {
      if (response["Status"] === 1) {
        const c = JSON.parse(JSON.stringify(response["CartItem"]));
        c.LoadingCell = false;
        this.applyCartItemToRow(rowIndex, c);
      }
      
      this.loadingProducts = false;
      // ✅ Inform that this row's async is done
      if (callback) callback();
    });
  }

  SwitchGridProductOffer(item:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.parent.B2BPartner?.ID,
      SelectedOffer:item.Product?.ListPriceOffers[0],
      CartItem:this.ClickedRow?.CartItem,
    };
  
    this.LoadingSideOffers = true;
  
    this.B2BService.SwitchGridProductOffer(request).subscribe(response => {
  
      if(response["Status"] != 1){
        // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var c = JSON.parse(JSON.stringify(response["CartItem"]));
        c.LoadingCell = false;
        this.applyCartItemToRow(this.ClickedRowIndex, c);
        this.UpdateCart();
      }
  
      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.LoadingSideOffers = false;
     });
  }

  SwitchGridBrandVersion2(b:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.parent.B2BPartner?.ID,
      CartItem:this.ClickedRow?.CartItem,
      Pager: { PageIndex: 1, PageSize: 10 },
      MaxRank: 10,
      UISelectedBrand:JSON.parse(JSON.stringify(b)),
    };
  
    this.LoadingSideOffers = true;
  
    this.B2BService.SwitchGridBrandVersion2(request).subscribe(response => {
  
      if(response["Status"] != 1){
        // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var c = JSON.parse(JSON.stringify(response["CartItem"]));
        c.LoadingCell = false;
        this.applyCartItemToRow(this.ClickedRowIndex, c);
        this.UpdateCart();

        //if still is awaiting selection:
        if(c?.CartItemStatus?.ID == -1){
          this.ShowUISideOffers(this.ClickedRowIndex, this.ClickedRow?.CartItem);
          this.ShowFallbackSelection = true;
        }
      }
  
      this.LoadingSideOffers = false;
      this.ShowBrandCollateral = false;
     });
  }

  BrandCollateralList:any[];
  BrandSelectList:any[];

  SearchIndustryProductB2BBrandsVersion2(rowIndex: number, cartItem: any) {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CurrentUISelectedBrand: cartItem?.Product?.Brand?.ID,
      SearchTerm: cartItem?.UIProductValue,
    };
  
    this.ShowBrandCollateral = true;
    this.LoadingSideOffers = true;
  
    this.B2BService.SearchIndustryProductB2BBrandsVersion2(request).subscribe(response => {
      if (response["Status"] === 1) {
        const brands = JSON.parse(JSON.stringify(response["Brands"] ?? []));
  
        // put brands on the specific row
        const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
        if (rowNode?.data) {
          const ci = rowNode.data.CartItem ?? (rowNode.data.CartItem = {});
          ci.CollateralBrands = brands;
  
          // (optional) persist to cart/localStorage
          if (this.parent.Cart?.Items?.[rowIndex]) {
            this.parent.Cart.Items[rowIndex].CollateralBrands = JSON.parse(JSON.stringify(brands));
            localStorage.setItem('Cart', JSON.stringify(this.parent.Cart));
          }
  
          // refresh brand cell so button/state reflects
          this.gridApi.refreshCells({ rowNodes: [rowNode], columns: ['brand'], force: true });
        }
  
        // show the brand popup now; position already computed in click handler
        this.BrandCollateralList = brands;
      }
  
      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.LoadingSideOffers = false;
    });
  }
  
  SearchIndustryProductNameAndPartNumberParrallelB2BBrandsVersion2(rowIndex: number, cartItem: any) {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CurrentUISelectedBrand: cartItem?.Product?.Brand?.ID,
      CartItem:JSON.parse(JSON.stringify(cartItem)),
    };
  
    this.ShowBrandCollateral = true;
    this.LoadingSideOffers = true;
  
    this.B2BService.SearchIndustryProductNameAndPartNumberParrallelB2BBrandsVersion2(request).subscribe(response => {
      if (response["Status"] === 1) {
        const brands = JSON.parse(JSON.stringify(response["Brands"] ?? []));
  
        // put brands on the specific row
        const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
        if (rowNode?.data) {
          const ci = rowNode.data.CartItem ?? (rowNode.data.CartItem = {});
          ci.CollateralBrands = brands;
  
          // (optional) persist to cart/localStorage
          if (this.parent.Cart?.Items?.[rowIndex]) {
            this.parent.Cart.Items[rowIndex].CollateralBrands = JSON.parse(JSON.stringify(brands));
            localStorage.setItem('Cart', JSON.stringify(this.parent.Cart));
          }
  
          // refresh brand cell so button/state reflects
          this.gridApi.refreshCells({ rowNodes: [rowNode], columns: ['brand'], force: true });
        }
  
        // show the brand popup now; position already computed in click handler
        this.BrandCollateralList = brands;
      }
  
      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.LoadingSideOffers = false;
    });
  }

  SwitchGridResultProduct(SelectedResult:any){

    if(SelectedResult.Price?.UIUnitPrice > 0){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        PartnerID:this.parent.B2BPartner?.ID,
        SelectedResult:SelectedResult,
        InitialCartItem:this.ClickedRow?.CartItem,
      };
    
      this.LoadingSideOffers = true;
    
      this.B2BService.SwitchGridResultProduct(request).subscribe(response => {
    
        if(response["Status"] != 1){
          // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var c = JSON.parse(JSON.stringify(response["CartItem"]));
          c.LoadingCell = false;
          this.applyCartItemToRow(this.ClickedRowIndex, c);
          this.UpdateCart();
        }
    
        this.ShowETAAlternatives = false;
        this.ShowSearchResultsAlternatives = false;
        this.LoadingSideOffers = false;
        this.ShowFallbackSelection = false;
       });
    }
  }

  private insertedOverflowUIIDs = new Set<string>();

  ChangeGridQuantityVersion2(rowIndex: number, quantity: any, item: any): void {
    if(this.loadingProducts != true){
      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        PartnerID: this.parent.B2BPartner?.ID,
        CartItem: item,
        Quantity: quantity
      };
    
      this.loadingProducts = true;
    
      this.B2BService.ChangeGridQuantityVersion2(request).subscribe(response => {
        if (response["Status"] !== 1) {
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        } else {
          const items = JSON.parse(JSON.stringify(response["CartItems"] ?? []));
          const seen = new Set();
    
          for (const item of items) {
            const key = item?.UIID ?? item?.Product?.ID;
            if (!seen.has(key)) {
              seen.add(key);
              this.applyCartItemToRow(rowIndex, item);
              break; // 🔥 Apply only the first relevant item
            }
          }
    
          this.UpdateCart();
        }
    
        this.loadingProducts = false;
      });
    }
  }
  
  private applyCartItemToRow(rowIndex: number, cartItem: any): void {
    if (!this.gridApi || !cartItem) return;
  
    const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;
  
    const brand = cartItem?.Product?.Brand?.Name ?? '';
    const name = cartItem?.UIProductValue ?? '';
    const partNumber = cartItem?.Product?.PartNumber ?? '';
    const quantity = cartItem?.Quantity ?? '';
  
    // ✅ Price logic: show '' if SellPrice is not > 0
    const sellPrice = cartItem?.SelectedOffer?.SellPrice?.UIUnitPrice;
    const showPrice = sellPrice > 0;
    const price = showPrice
      ? `${sellPrice} ${cartItem?.Price?.Currency?.Name ?? ''}`
      : '';
  
    const total = cartItem?.Price?.UIQtyPrice != null
      ? `${cartItem.Price.UIQtyPrice} ${cartItem.Price.Currency?.Name ?? ''}`
      : '';
  
    const eta = cartItem?.SelectedOffer?.LeadTime?.Units > 0
      ? `${cartItem.SelectedOffer.LeadTime.Units} ${cartItem.SelectedOffer.LeadTime.Type?.Name ?? ''}`
      : '------';
  
    const hscode = cartItem?.Product?.Stats?.HSCode ?? '';
    const coo = cartItem?.Product?.Stats?.COO?.ShortName ?? '';
    const weight = cartItem?.Product?.Stats?.Weight != null
      ? `${cartItem.Product.Stats.Weight} ${cartItem.Product.Stats.WeightMeasurementType?.Name ?? ''}`
      : '';
  
    rowNode.setData({
      index: rowIndex + 1,
      brand,
      partNumber,
      name,
      quantity,
      price,
      total,
      eta,
      hscode,
      coo,
      weight,
      CartItem: JSON.parse(JSON.stringify(cartItem))
    });
  
    // === Overflow logic continues below as-is ===
    const isOverflowNeeded =
      cartItem?.SelectedOffer?.StockOverRequestedQuantity > 0 &&
      !cartItem.IsOverflowRow;
  
    const nextRow = this.gridApi.getDisplayedRowAtIndex(rowIndex + 1);
    const isNextAlreadyOverflow = nextRow?.data?.CartItem?.IsOverflowRow === true;
  
    const uiid = cartItem?.UIID;
    if (!isOverflowNeeded || isNextAlreadyOverflow || this.insertedOverflowUIIDs.has(uiid)) {
      this.gridApi.refreshCells({ rowNodes: [rowNode], force: true });
      return;
    }
  
    this.insertedOverflowUIIDs.add(uiid);
  
    const clonedCartItem = JSON.parse(JSON.stringify(cartItem));
    clonedCartItem.IsOverflowRow = true;
    clonedCartItem.Quantity = 0;
    clonedCartItem.LoadingCell = true;
  
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CartItem: clonedCartItem
    };
  
    this.B2BService.GetIndustryProductByStockOverRequestedQuantity(request).subscribe(response => {
      if (response["Status"] === 1 && response["CartItem"]) {
        const overflowItem = JSON.parse(JSON.stringify(response["CartItem"]));
        const overflowUIID = overflowItem?.UIID;
  
        if (!overflowUIID || this.insertedOverflowUIIDs.has(overflowUIID)) return;
        this.insertedOverflowUIIDs.add(overflowUIID);
  
        const newRow = {
          index: rowIndex + 2,
          brand: overflowItem?.Product?.Brand?.Name ?? '',
          partNumber: overflowItem?.Product?.PartNumber ?? '',
          name: overflowItem?.UIProductValue ?? '',
          quantity: overflowItem?.Quantity ?? '',
          price: (overflowItem?.SelectedOffer?.SellPrice?.UIUnitPrice > 0)
            ? `${overflowItem.SelectedOffer.SellPrice.UIUnitPrice} ${overflowItem.Price?.Currency?.Name ?? ''}`
            : '',
          total: overflowItem?.Price?.UIQtyPrice != null
            ? `${overflowItem.Price.UIQtyPrice} ${overflowItem.Price.Currency?.Name ?? ''}`
            : '',
          eta: overflowItem?.SelectedOffer?.LeadTime?.Units > 0
            ? `${overflowItem.SelectedOffer.LeadTime.Units} ${overflowItem.SelectedOffer.LeadTime.Type?.Name ?? ''}`
            : '------',
          hscode: overflowItem?.Product?.Stats?.HSCode ?? '',
          coo: overflowItem?.Product?.Stats?.COO?.ShortName ?? '',
          weight: overflowItem?.Product?.Stats?.Weight != null
            ? `${overflowItem.Product.Stats.Weight} ${overflowItem.Product.Stats.WeightMeasurementType?.Name ?? ''}`
            : '',
          CartItem: overflowItem
        };
  
        this.gridApi.applyTransaction({ add: [newRow], addIndex: rowIndex + 1 });
        this.parent.Cart.Items.splice(rowIndex + 1, 0, overflowItem);
        localStorage.setItem("Cart", JSON.stringify(this.parent.Cart));
      } else {
        clonedCartItem.LoadingCell = false;
        this.parent.openSnackBar(response["Message"] ?? "Overflow error", "OK", "alert-info-snackbar");
      }
    });
  
    this.gridApi.refreshCells({ rowNodes: [rowNode], force: true });
  }
  
  
  exportToExcel(): void {
    if (this.gridApi) {
      this.gridApi.exportDataAsExcel({
        fileName: 'grid-export.xlsx',
        sheetName: 'Sheet1'
      });
    }
  }

  onCellClicked: (event: any) => {
   
  }
  
   /** Parse numbers for quantity */
   numberParser(params: any): number {
    const val = Number(params.newValue);
    return isNaN(val) ? params.oldValue : val;
  }

  /** Format decimal values for price/total */
  decimalFormatter(params: any): string {
    return params.value != null ? parseFloat(params.value).toFixed(2) : '';
  }
  
  SelectedCartItem:any;

  SelectGridItem(item:any){
    this.SelectedCartItem = JSON.parse(JSON.stringify(item));
  }

  Filter: {[k: string]: any} = {};

  InitializeFilter(){

  this.Filter = {};
  this.Filter.SearchTerm = "";

  this.Filter.Pager = {};
  this.Filter.Pager.PageIndex = 1;
  this.Filter.Pager.PageSize = 50;
  this.Filter.Pager.TotalCount = 0;

  this.Filter.Company = {};
  this.Filter.Company = null;

  this.Filter.Brand = {};
  this.Filter.Brand = null;

  this.Filter.ProductBoxStatus = {};
  this.Filter.ProductBoxStatus = null;

  this.Filter.ProductConditionStatus = {};
  this.Filter.ProductConditionStatus = null;

  this.Filter.ProductManufacturingStatus = {};
  this.Filter.ProductManufacturingStatus = null;

  this.Filter.ProductVersionStatus = {};
  this.Filter.ProductVersionStatus = null;

  this.Filter.Creator = {};
  this.Filter.Creator = null;

  this.Filter.Updater = {};
  this.Filter.Updater = null;

  this.Filter.CombineProductsByID = true;
}



ShowSearchProductsPageMessage:boolean;

loadingProducts:boolean;
SearchedProducts:any[];
CartItemRows: {[k: string]: any} = [];

InitializeSearchProduct(item:any){

  this.CurrentCartItemRow = item;
  this.SelectItem(item);

  if((this.SearchedProducts == null || this.SearchedProducts.length == 0) && this.Filter.SearchTerm?.length > 2){
    this.SearchIndustryProducts();
  }
}

OfferPriorityStatuses:any[];
OfferPriorityStatus:any;

PopulateCartItems(rows = 50){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Rows:rows
  };

  this.loadingProducts = true;

  this.B2BService.PopulateCartItems(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var CI = JSON.parse(JSON.stringify(response["CartItems"]));
      this.CartItemRows = this.CartItemRows.concat(CI);

      if(this.OfferPriorityStatuses == null || this.OfferPriorityStatuses?.length == 0){
        this.OfferPriorityStatuses = response["OfferPriorityStatuses"];
        this.OfferPriorityStatus = this.OfferPriorityStatuses[0];
      }
    }

    this.loadingProducts = false;
   });
}

GetIndustryProductsStocksFiltered(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingProducts = true;

  this.managementService.GetIndustryProductsStocksFiltered(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SearchedProducts = response["StockProducts"];
    }

    this.loadingProducts = false;
   });
}

AllSelected:boolean;

SelectAll(){
  this.parent.Cart.Items.forEach(r => {
    r.IsSelected = this.AllSelected;
  });

  this.CheckIfAnyChecked();
}

AnyChecked:boolean;

CheckIfAnyChecked(){
  this.AnyChecked = false;

  this.parent.Cart.Items.forEach(element => {
    if(element.IsSelected){
      this.AnyChecked = true;
    }
  });
}

SearchIndustryProducts(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingProducts = true;

  this.managementService.SearchIndustryProducts(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SearchedProducts = response["SearchResults"];
    }

    this.loadingProducts = false;
   });
}

SelectItem(i:any){
  this.CartItemRows.forEach(cell => {
    if(cell.UIID == i.UIID){
      cell.IsSelected = !cell.IsSelected;
    }
    else{
      cell.IsSelected = false;
    }
  });
}

SplitGetIndustryProductsSearchQuery(searchQuery:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchQuery:searchQuery,
    UIID:this.CurrentCartItemRow.UIID,
    CartItems:this.CartItemRows,
    Partner:this.parent.B2BPartner
  };

  this.CartItemRows.forEach(cell => {
      if(cell.UIID == this.CurrentCartItemRow.UIID){
        cell.LoadingCell = true;
      }
  });

  this.B2BService.SplitGetIndustryProductsSearchQuery(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CartItemRows = [];
      this.CartItemRows = JSON.parse(JSON.stringify(response["CartItems"]));

      this.CartItemRows.filter(x => !x.WasSearchedFor && x.UIProductValue?.length > 0).forEach(cell => {
        this.SearchIndustryProductsFromGridCell(cell);
      });
    }

    this.searchTermUpdate.next(null);
   });
}

SearchIndustryProductsFromGridCell(item:any){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    UIID:item.UIID,
    CartItem:item,
  };

  this.CartItemRows.forEach(cell => {
      if(cell.UIID == item.UIID){
        cell.LoadingCell = true;
      }
  });

  this.B2BService.SearchIndustryProductsFromGridCell(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Item = response["CartItem"];

      this.CartItemRows.forEach((cell, index) => {
        if(cell.UIID == item.UIID){
            this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));
            this.GetGridCellItemData(JSON.parse(JSON.stringify(this.CartItemRows[index])));
        }
      });
    }

    this.CartItemRows.forEach(cell => {
      if(cell.UIID == item.UIID){
        cell.LoadingCell = false;
      }
    });

    this.searchTermUpdate.next(null);
   });
}

SelectGridSearchResult(s:any, item:any){

  item.SearchResults.forEach(element => {
    element.IsSelected = false;
  });

  // Find the index of the matching search result
const index = item.SearchResults.findIndex(searchResult => searchResult.UIID === s.UIID);

// If a matching search result is found
if (index !== -1) {
    // Set isSelected to true
    item.SearchResults[index].IsSelected = true;

    // Move the matching search result to the beginning of the array
    const selectedSearchResult = item.SearchResults.splice(index, 1)[0];
    item.SearchResults.unshift(selectedSearchResult);
}

  this.GetGridCellItemData(JSON.parse(JSON.stringify(item)));
  item.IsSelected = false;
}

GetGridCellItemData(c:any){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    newItem:c,
    Partner:this.parent.B2BPartner
  };

  this.B2BService.GetGridCellItemData(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Item = response["Item"];

      this.CartItemRows.forEach((cell, index) => {
        if(cell.UIID == c.UIID){
            this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));
        }
    });
    }
   });
}

ExportB2BGrid(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    CartItems:this.CartItemRows,
  };

  this.parent.loading = true;

  this.B2BService.ExportB2BGrid(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }
   });

   this.parent.loading = false;
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

ShowAllProductsDetails:boolean = false;

ShowAllProductsDetailsFunction(e:boolean){
  this.ShowAllProductsDetails = e;
  this.parent.Cart.Items.forEach(element => {
    element.Product.ShowDetails = e;
  });
}

CloseShowSearchProductsPageMessage(){
  this.cookieService.set("SearchProductsPageMessage", "true");
  this.ShowSearchProductsPageMessage = false;
}

B2BHomePageMessage:string;

GetB2BHomePageMessage(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:this.parent.B2BPartner,
    Agent:this.parent.B2BAgent
  };

  this.loadingProducts = true;

  this.B2BService.GetB2BHomePageMessage(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShowSearchProductsPageMessage = true;
      this.B2BHomePageMessage = response["B2BHomePageMessage"];
      this.GetB2BListedBrands();
    }

    this.loadingProducts = false;
   });
}

Brands:any[];
loadingBrandIcons:boolean = false;

GetB2BListedBrands(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };

  this.loadingBrandIcons = true;

  this.B2BService.GetB2BListedBrands(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Brands = JSON.parse(JSON.stringify(response["Brands"]));
    }

    this.loadingBrandIcons = false;
   });
}

InitializeBrandFilter(){
  this.BrandFilter = {};
  this.BrandFilter.SearchTerm = "";
  this.BrandFilter.Pager = {};
  this.BrandFilter.Pager.PageIndex = 1;
  this.BrandFilter.Pager.PageSize = 50;
  this.BrandFilter.Pager.TotalCount = 0;
}

BrandsLoading:boolean = false;
BrandFilter: {[k: string]: any} = {};
ShowBrandCollateralNewProduct:boolean = false;

AttachBrandToNewProduct(b: any) {
  // 1) Get the live row node (avoid using a stale copy from ClickedRow)
  const rn = this.gridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
  if (!rn) {
    return;
  }

  // 2) Current row data & cart item
  const current = rn.data || {};
  const cartItem = current.CartItem || {};

  // 3) Update CartItem product info
  cartItem.Product = cartItem.Product || {};
  cartItem.Product.Brand = JSON.parse(JSON.stringify(b));

  // Take UI text from the Name cell as product name if available
  const uiValue = (cartItem.UIProductValue ?? current.name ?? '').toString().trim();
  cartItem.UIProductValue = uiValue;                 // keep UI value in sync
  cartItem.Product.Name = uiValue;                   // show same as product name

  // 4) Update the TOP-LEVEL fields used by your columnDefs
  const newBrandName = b?.Name ?? b?.name ?? '';
  const updatedRow = {
    ...current,
    brand: newBrandName,                              // <-- this is what Brand column displays
    name: uiValue,                                    // <-- Name column displays this
    CartItem: JSON.parse(JSON.stringify(cartItem))    // deep copy to avoid ref issues
  };

  // 5) Apply to the grid row (cheap, no full rebind)
  rn.setData(updatedRow);

  // 6) Refresh just what’s needed
  this.gridApi.refreshCells({
    rowNodes: [rn],
    columns: ['brand', 'name'],   // must match your colDef.field values
    force: true
  });
  this.gridApi.redrawRows({ rowNodes: [rn] });

  // 7) Persist to Cart + localStorage (so a later full refresh matches the UI)
  if (this.parent.Cart?.Items) {
    this.parent.Cart.Items[this.ClickedRowIndex] = JSON.parse(JSON.stringify(cartItem));
    localStorage.setItem('Cart', JSON.stringify(this.parent.Cart));
  }

  // 8) (Optional) If you want server-side normalization now, keep UpdateCart();
  //    It will re-run InitializeCart and re-render the whole grid.
  //    If you want only immediate local UI, you can remove the next line.
  this.UpdateCart();

  // 9) Close popup
  this.ShowBrandCollateralNewProduct = false;
}

GetBrandsFilteredWithSuggestion(searchTerm: string, page = 1, implicitProduct: string = null) {
  // keep filter values in sync
  this.BrandFilter.Pager.PageIndex = page;
  this.BrandFilter.SearchTerm = searchTerm ?? '';

  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Filter: this.BrandFilter,
    Product: implicitProduct ?? null
  };

  this.LoadingSideOffers = true;

  this.managementService.GetBrandsFilteredWithSuggestion(request).subscribe(response => {
    try {
      if (response['Status'] !== 1) {
        this.parent.openSnackBar(response['Message'], 'OK', 'alert-info-snackbar');
        return;
      }

      // 1) Update source-of-truth list
      this.Brands = response['Brands'] ?? [];

      // 2) If we’re in a grid context (we set ClickedRowIndex on click), mirror to the row
      if (typeof this.ClickedRowIndex === 'number') {
        const rowNode = this.gridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
        if (rowNode?.data) {
          const ci = rowNode.data.CartItem ?? (rowNode.data.CartItem = {});
          ci.CollateralBrands = JSON.parse(JSON.stringify(this.Brands));

          // persist to Cart + localStorage if available
          if (this.parent.Cart?.Items?.[this.ClickedRowIndex]) {
            this.parent.Cart.Items[this.ClickedRowIndex].CollateralBrands = JSON.parse(JSON.stringify(this.Brands));
            localStorage.setItem('Cart', JSON.stringify(this.parent.Cart));
          }

          // refresh only the brand cell (button state remains consistent)
          this.gridApi.refreshCells({
            rowNodes: [rowNode],
            columns: ['brand'],
            force: true
          });
        }
      }

      // 3) Feed the popup with the SAME model used elsewhere
      this.BrandSelectList = JSON.parse(JSON.stringify(this.Brands));
      this.ShowBrandCollateralNewProduct = true;    // ensure opened (in case it was closed)
    }
    finally {
      this.LoadingSideOffers = false;
    }
  });
}

onSelectSearchResultAlternative(s:any){
  s.Loading = true;
}

addMoreRows(count: number = 50): void {
  if (!this.gridApi) return;

  const currentCount = this.gridApi.getDisplayedRowCount();
  const newRows: any[] = [];

  for (let i = 0; i < count; i++) {
    const row = {
      index: currentCount + i + 1,
      brand: '',
      partNumber: '',
      name: '',
      quantity: null,
      price: null,
      total: null,
      eta: '',
      hscode: '',
      coo: '',
      weight: '',
      CartItem: {}
    };

    this.CartItemRows.push(row);     // if you still need it for logic
    newRows.push(row);
  }

  // 🔥 THIS is what updates the grid
  this.gridApi.applyTransaction({ add: newRows });
  console.log('✅ Adding rows:', newRows.length);
}

ClearGridQuestion:boolean;

AskClearGridQuestion(){
  this.ClearGridQuestion = true;
}

ClearGrid(): void {
  const updatedRows: any[] = [];

  this.gridApi.forEachNode((_, index) => {
    updatedRows.push({
      index: index + 1,
      brand: '',
      partNumber: '',
      name: '',
      quantity: null,
      price: null,
      total: null,
      eta: '',
      hscode: '',
      coo: '',
      weight: '',
      CartItem: {}
    });
  });

  this.gridApi.setRowData(updatedRows);
  this.UpdateCart();

  console.log('🧹 Grid fully cleared and cart emptied.');
}

GetCart(): void {
  const storedCart = localStorage.getItem("Cart");
  if (!storedCart) return;

  this.parent.Cart = JSON.parse(storedCart);

  const items = this.parent.Cart?.Items ?? [];
  const rows = items.map((cartItem, index) => {
    const product = cartItem?.Product ?? {};
    const stats = product?.Stats ?? {};
    const price = cartItem?.Price ?? {};
    const leadTime = cartItem?.SelectedOffer?.LeadTime;

    const eta = leadTime?.Units && leadTime.Units > 0
      ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}`
      : '------';

    return {
      index: index + 1,
      brand: product?.Brand?.Name ?? '',
      partNumber: product?.PartNumber ?? '',
      name: cartItem?.UIProductValue ?? '',
      quantity: cartItem?.Quantity ?? null,
      price: price?.UIUnitPrice != null
        ? `${price.UIUnitPrice} ${price.Currency?.Name ?? ''}`
        : '',
      total: price?.UIQtyPrice != null
        ? `${price.UIQtyPrice} ${price.Currency?.Name ?? ''}`
        : '',
      eta,
      hscode: stats?.HSCode ?? '',
      coo: stats?.COO?.ShortName ?? '',
      weight: stats?.Weight != null
        ? `${stats.Weight} ${stats.WeightMeasurementType?.Name ?? ''}` : '',
      CartItem: JSON.parse(JSON.stringify(cartItem))
    };
  });

  this.gridApi.setRowData(rows);
  console.log(`🛒 Loaded ${rows.length} items into the grid from localStorage.`);
}

deliveryPreferences: any[] = [
  { value: 1, label: 'Standard' },
  { value: 2, label: 'Express' },
  { value: 3, label: 'Pickup' }
];

selectedPref: any;

UpdateCart(){
  const items: any[] = [];

  // Loop over all displayed rows in AG Grid
  this.gridApi.forEachNode((node) => {
    const cartItem = node.data?.CartItem;
    if (cartItem) {
      items.push(JSON.parse(JSON.stringify(cartItem))); // deep copy to avoid reference issues
    }
  });

  this.parent.Cart.Items = items;
  this.InitializeCart();
}

InitializeCart(): void {
  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Cart: this.parent.Cart,
    Client: this.parent.B2BPartner,
    B2BMasterData: this.parent.CartMasterData
  };

  this.parent.loading = true;

  this.B2BService.InitializeCart(request).subscribe(response => {
    if (response["Status"] !== 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      this.parent.loading = false;
      return;
    }

    this.parent.Cart = response["Cart"];
    this.parent.CartMasterData = response["B2BMasterData"];
    const hasChanges = response["HasChanges"] === true;

    localStorage.setItem('Cart', JSON.stringify(this.parent.Cart));

    if (hasChanges && this.gridApi) {
      const items = this.parent.Cart?.Items ?? [];

      const rows = items.map((cartItem, index) => {
        const product = cartItem?.Product ?? {};
        const stats = product?.Stats ?? {};
        const leadTime = cartItem?.SelectedOffer?.LeadTime ?? {};
        const priceInfo = cartItem?.Price ?? {};
        const currency = priceInfo?.Currency?.Name ?? '';
        const sellPrice = cartItem?.SelectedOffer?.SellPrice?.UIUnitPrice;

        const price = sellPrice > 0 ? `${sellPrice} ${currency}` : '';
        const total = priceInfo?.UIQtyPrice != null ? `${priceInfo.UIQtyPrice} ${currency}` : '';
        const eta = leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------';

        return {
          index: index + 1,
          brand: product?.Brand?.Name ?? '',
          partNumber: product?.PartNumber ?? '',
          name: cartItem?.UIProductValue ?? '',
          quantity: cartItem?.Quantity ?? null,
          price,
          total,
          eta,
          hscode: stats?.HSCode ?? '',
          coo: stats?.COO?.ShortName ?? '',
          weight: stats?.Weight != null
            ? `${stats.Weight} ${stats.WeightMeasurementType?.Name ?? ''}` : '',
          CartItem: JSON.parse(JSON.stringify(cartItem))
        };
      });

      this.gridApi.setRowData(rows);
      console.log(`🔁 Grid re-rendered due to cart changes (${rows.length} rows).`);
    }

    this.parent.loading = false;
  });
}


}
